import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MeetingEvidenceDto } from '@interfaces/meetings/responses/meeting-insights.response';
import { formatarMarcaDeTempo } from '@features/dashboard/meetings/components/meeting-presenter';

/**
 * Trechos de fala que sustentam um item do Cog (próximo passo, vínculo sugerido): quem falou, o tempo
 * e a citação. Clicar no tempo leva o vídeo ao ponto (PBI 3225).
 */
@Component({
  selector: 'app-meeting-evidence',
  standalone: true,
  template: `
    <ul class="evidence">
      @for (trecho of trechos(); track $index) {
        <li class="evidence__item">
          @if (temVideo() && trecho.startSeconds !== null) {
            <button
              type="button"
              class="evidence__time"
              [title]="'Ir para ' + trecho.tempo + ' no vídeo'"
              (click)="irPara.emit(trecho.startSeconds ?? 0)">
              {{ trecho.tempo }}
            </button>
          } @else if (trecho.startSeconds !== null) {
            <span class="evidence__time evidence__time--static">{{ trecho.tempo }}</span>
          }
          <q class="evidence__quote">{{ trecho.quote }}</q>
          @if (trecho.speaker) {
            <span class="evidence__speaker">{{ trecho.speaker }}</span>
          }
        </li>
      }
    </ul>
  `,
  styles: `
    .evidence {
      display: flex;
      flex-direction: column;
      gap: 0.3rem;
      margin: 0.35rem 0 0;
      padding: 0;
      list-style: none;
    }
    .evidence__item {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      gap: 0.35rem;
      padding-left: 0.6rem;
      border-left: 2px solid #e5e7eb;
      font-size: 0.8rem;
      color: #4b5563;
    }
    .evidence__time {
      padding: 0.02rem 0.35rem;
      border: 0;
      border-radius: 4px;
      background: #eef0f2;
      font: inherit;
      font-size: 0.7rem;
      font-variant-numeric: tabular-nums;
      color: #0b5f7e;
      cursor: pointer;
    }
    .evidence__time--static {
      color: #6b7280;
      cursor: default;
    }
    .evidence__quote {
      font-style: italic;
    }
    .evidence__speaker {
      color: #9ca3af;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingEvidenceComponent {
  readonly evidencias = input<MeetingEvidenceDto[]>([]);
  readonly temVideo = input(false);

  readonly irPara = output<number>();

  protected readonly trechos = computed(() =>
    this.evidencias().map(e => ({ ...e, tempo: formatarMarcaDeTempo(e.startSeconds) }))
  );
}
